// Select all condition tool containers
const conditionTools = document.querySelectorAll('.conditions-and-treatments-tool');

// Function to toggle elements for each conditionTool instance
function toggleElements(conditionTool, categoriesList, categoriesLabel) {
  if (conditionTool.classList.contains('is-condensed')) {
    // Hide categoriesList and remove "active" class from categoriesLabel
    categoriesList.style.display = 'none';
    categoriesLabel.classList.remove('active');
  } else {
    // Show categoriesList as grid and add "active" class to categoriesLabel
    categoriesList.style.display = 'grid';
    categoriesLabel.classList.add('active');
  }
}

// Iterate over all condition tools
conditionTools.forEach((conditionTool) => {
  const categoriesList = conditionTool.querySelector('.condition-tool__categories-list');
  const categoriesLabel = conditionTool.querySelector('.condition-tool__categories-label-button');
  const conditionCategoryLinks = conditionTool.querySelectorAll('.condition-tool__categories-item');

  if (!categoriesList || !categoriesLabel) return; // Ensure elements exist

  // Track the previous state of the class
  let wasCondensed = conditionTool.classList.contains('is-condensed');

  // Call the function initially to set the state
  toggleElements(conditionTool, categoriesList, categoriesLabel);

  // Add a click event listener to categoriesLabel
  categoriesLabel.addEventListener('click', () => {
    // Toggle the display of categoriesList
    if (categoriesList.style.display === 'none' || categoriesList.style.display === '') {
      categoriesList.style.display = 'grid'; // Show categoriesList
      categoriesLabel.classList.add('active'); // Add "active" class
    } else {
      categoriesList.style.display = 'none'; // Hide categoriesList
      categoriesLabel.classList.remove('active'); // Remove "active" class
    }
  });

  // Add an event listener to each <a> tag within this conditionTool
  conditionCategoryLinks.forEach((link) => {
    link.addEventListener('click', () => {
      if (conditionTool.classList.contains('is-condensed')) {
        categoriesList.style.display = 'none';
        categoriesLabel.classList.remove('active');
      }
    });
  });

  // Create a MutationObserver to detect changes in conditionTool's classes
  const observer = new MutationObserver(() => {
    const isCondensed = conditionTool.classList.contains('is-condensed');

    // Only run the function if the class was added or removed
    if (isCondensed !== wasCondensed) {
      toggleElements(conditionTool, categoriesList, categoriesLabel);
      wasCondensed = isCondensed; // Update the previous state
    }
  });

  // Configure and observe changes in the class attribute of this conditionTool
  observer.observe(conditionTool, { attributes: true, attributeFilter: ['class'] });
});
